// extracted by mini-css-extract-plugin
module.exports = {"rating-text":"styles-module__rating-text____6CMO"};